import { usePlayer } from "../../player/context.js";
import { renderElement } from "../../utils/use-render.js";
import { PosterProvider } from "./context.js";
import { PosterCore, PosterDataAttrs } from "@videojs/core";
import { logMissingFeature, selectMetadata, selectPlayback } from "@videojs/core/dom";
import { forwardRef, useState } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/ui/poster/root.tsx
/**
* Manages poster visibility and image loading state.
*
* Renders a `div` and exposes `data-visible`, `data-loading`, `data-loaded`, and `data-error` for styling every layer
* in the poster presentation. Render `Poster.Image` inside it for the image that supplies the loading lifecycle.
*/
const PosterRoot = forwardRef(function PosterRoot(componentProps, forwardedRef) {
	const { render, className, style, ...elementProps } = componentProps;
	const playback = usePlayer(selectPlayback);
	const metadata = usePlayer(selectMetadata);
	const [core] = useState(() => new PosterCore());
	const [reportedLoadState, setImageLoadState] = useState(null);
	if (!playback) {
		logMissingFeature("Poster.Root", "playback");
		return null;
	}
	core.setMedia({
		started: playback.started,
		poster: metadata?.poster ?? ""
	});
	core.setImageLoadState(reportedLoadState ?? (metadata?.poster ? "loading" : "none"));
	const state = core.getState();
	return /* @__PURE__ */ jsx(PosterProvider, {
		value: {
			state,
			setImageLoadState
		},
		children: renderElement("div", {
			render,
			className,
			style
		}, {
			state,
			stateAttrMap: PosterDataAttrs,
			ref: forwardedRef,
			props: elementProps
		})
	});
});
//#endregion
export { PosterRoot };

//# sourceMappingURL=root.js.map